import React, { useState, Fragment } from "react";
import { EmblaCarousel } from "../../EmblaCarousel";
import { User, Location } from "@ecologi/shared";
import { EquivalentCard, TypeKey } from "./EquivalentCard";
import { InfoModal } from "./InfoModal";
import styles from "../styles/CarbonEquivalents.module.scss";
import useMedia from "react-use/lib/useMedia";

type Props = {
  user: User;
  location: Location;
};

export const CarbonEquivalents: React.FC<Props> = ({ user, location }) => {
  const [infoPopupTypeKey, setInfoPopupTypeKey] = useState<TypeKey | null>(
    null
  );

  const isShowKMs = location
    ? location.countryCode === "EU"
    : user.country === "EU";

  const props = {
    setInfoPopupTypeKey,
    isShowKMs,
    tonnesOfCO2: user.totalNumberOfTonnesOffset(),
  };

  const cards = [
    <EquivalentCard key="eq-1" typeKey="flights" {...props} />,
    <EquivalentCard key="eq-2" typeKey="ice" {...props} />,
    <EquivalentCard key="eq-3" typeKey="car" {...props} />,
  ];
  const isDesktop = useMedia("(max-width: 767px)");

  return (
    <Fragment>
      <ul className={styles.carbonEquivalentsList}>
        {isDesktop ? <EmblaCarousel slides={cards} /> : <>{cards}</>}
      </ul>
      <InfoModal
        typeKey={infoPopupTypeKey}
        close={() => {
          setInfoPopupTypeKey(null);
        }}
      />
    </Fragment>
  );
};
